export default "__VITE_ASSET__DvtRlQg3__"